import type { SceneTransition } from './types';

export interface IdScene { id: number }

export function reconcileTransitions(
  prev: IdScene[],
  next: IdScene[],
  transitions: SceneTransition[],
): SceneTransition[] {
  if (transitions.length === 0) return transitions;

  const nextPos = new Map<number, number>();
  next.forEach((s, i) => nextPos.set(s.id, i));

  const claimed = new Map<number, SceneTransition>();
  const sorted = [...transitions].sort((a, b) => a.afterSceneIndex - b.afterSceneIndex);
  for (const t of sorted) {
    // The cut is "before" this scene; walk forward through prev until a
    // scene that still exists in next (handles deletes of the follower).
    let pos = -1;
    for (let k = t.afterSceneIndex + 1; k < prev.length; k++) {
      const p = nextPos.get(prev[k].id);
      if (p !== undefined) { pos = p; break; }
    }
    if (pos < 1) continue; // follower gone, or now the first scene: cut no longer exists
    const idx = pos - 1;
    if (!claimed.has(idx)) claimed.set(idx, { ...t, afterSceneIndex: idx });
  }

  const out = [...claimed.values()].sort((a, b) => a.afterSceneIndex - b.afterSceneIndex);

  // Same-reference fast path so every intervals update can call this freely.
  if (
    out.length === transitions.length &&
    out.every((t, i) =>
      t.afterSceneIndex === transitions[i].afterSceneIndex &&
      t.kind === transitions[i].kind &&
      t.durationSec === transitions[i].durationSec &&
      t.direction === transitions[i].direction)
  ) {
    return transitions;
  }
  return out;
}
